module.exports = __webpack_public_path__ + "img/pr-4.10d5ca6a.png";